import { useEffect, useState } from "react";
import { Type } from "lucide-react";

export default function TextSizeToggle() {
    const [large, setLarge] = useState(false);

    useEffect(() => {
        setLarge(document.documentElement.classList.contains("text-plus"));
    }, []);

    const toggle = () => {
        const next = !large;
        setLarge(next);
        document.documentElement.classList.toggle("text-plus", next);
        try {
            localStorage.setItem("fsr-text-plus", next ? "1" : "0");
        } catch {
            // persistence unavailable — the toggle still works for this visit
        }
    };

    return (
        <button
            type="button"
            onClick={toggle}
            aria-pressed={large}
            title="Switch to larger text"
            data-testid="text-size-toggle"
            className={`text-size-toggle inline-flex h-12 items-center gap-2 whitespace-nowrap rounded-full border-2 px-4 text-base font-semibold transition-colors duration-200 ${
                large
                    ? "border-teal-700 bg-teal-700 text-white"
                    : "border-ink bg-transparent text-ink hover:bg-ink hover:text-cream"
            }`}
        >
            <Type className="h-5 w-5" aria-hidden="true" />
            <span className="toggle-text hidden sm:inline">{large ? "Larger text on" : "Larger text"}</span>
            <span className="toggle-aa sm:hidden" aria-hidden="true">
                Aa
            </span>
        </button>
    );
}